// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__ysKDD","footer":"ModalInfo_footer__1LPNF"};